export type AIGatewayPackKey =
  | 'starter'
  | 'business'
  | 'enterprise'
  | 'rag_starter'
  | 'rag_business'
  | 'rag_enterprise';

export type AIGatewayWalletType = 'models' | 'rag';

export interface AIGatewayPublicPack {
  key: AIGatewayPackKey;
  name: string;
  nameEn: string;
  price: string;        // e.g. "$50 USD"
  usdCents: number;     // e.g. 5000
  credits: string;      // e.g. "5,000 créditos"
  walletType: AIGatewayWalletType;
  popular?: boolean;
  features?: string[];
}

/** Nombre de la bolsa en el idioma de la página pública. */
export function packName(pack: AIGatewayPublicPack, locale: string): string {
  return locale === 'en' ? pack.nameEn : pack.name;
}

// Recargas de saldo único (wallet unificado 2026-07-13). Un solo saldo cubre
// chat Y documentos; cada monto se acredita ahí. NUNCA listar límites falsos
// ("hasta N keys/librerías") — el backend no los valida. Las equivalencias
// (≈ preguntas / ≈ páginas) se derivan del precio, no son features fijos.
export const AI_GATEWAY_MODEL_PACKS: AIGatewayPublicPack[] = [
  {
    key: 'starter',
    name: 'Recarga chica',
    nameEn: 'Small top-up',
    price: '$50',
    usdCents: 5_000,
    credits: '$50 de saldo',
    walletType: 'models',
    features: ['≈ 5,000 preguntas o páginas', 'Sin mensualidad, el saldo no caduca'],
  },
  {
    key: 'business',
    name: 'Recarga mediana',
    nameEn: 'Medium top-up',
    price: '$250',
    usdCents: 25_000,
    credits: '$250 de saldo',
    walletType: 'models',
    popular: true,
    features: ['≈ 25,000 preguntas o páginas', 'Sin mensualidad, el saldo no caduca'],
  },
  {
    key: 'enterprise',
    name: 'Recarga grande',
    nameEn: 'Large top-up',
    price: '$1,000',
    usdCents: 100_000,
    credits: '$1,000 de saldo',
    walletType: 'models',
    features: ['≈ 100,000 preguntas o páginas', 'Sin mensualidad, el saldo no caduca'],
  },
];

// Compat: algunos módulos aún importan AI_GATEWAY_RAG_PACKS. Con el saldo único
// ya no hay packs RAG separados; se deja vacío para no romper imports.
export const AI_GATEWAY_RAG_PACKS: AIGatewayPublicPack[] = [];

export const AI_GATEWAY_PUBLIC_PACKS: AIGatewayPublicPack[] = [
  ...AI_GATEWAY_MODEL_PACKS,
];

export function getAIGatewayPublicPack(key: string): AIGatewayPublicPack | undefined {
  return AI_GATEWAY_PUBLIC_PACKS.find((p) => p.key === key);
}

// ---------------------------------------------------------------------------
// Planes fijos mensuales (2026-07-24) — oferta enterprise/gobierno.
// Precio FIJO EN USD (CFDI en MXN al tipo de cambio del día) para que el tipo
// de cambio no erosione el margen. Los créditos incluidos tienen ~20% de
// descuento vs. su valor nominal: ni en el peor caso (100% chat, costo ×2)
// el margen baja de ~37%. Si el plan se acaba, se recarga a 1¢ el crédito.
// Activación por contacto/admin (fondeo mensual con vigencia); sin código de
// suscripción todavía.
export interface AIGatewayPlan {
  key: 'dependencia' | 'municipio' | 'ciudad';
  name: string;
  priceUsdMonthly: number;      // 199
  creditsMonthly: number;       // 25000
  creditsValueUsd: number;      // 250 (valor nominal de los créditos)
  popular?: boolean;
}

export const AI_GATEWAY_PLANS: AIGatewayPlan[] = [
  { key: 'dependencia', name: 'Dependencia', priceUsdMonthly: 199, creditsMonthly: 25_000, creditsValueUsd: 250 },
  { key: 'municipio', name: 'Municipio', priceUsdMonthly: 490, creditsMonthly: 60_000, creditsValueUsd: 600, popular: true },
  { key: 'ciudad', name: 'Ciudad', priceUsdMonthly: 990, creditsMonthly: 130_000, creditsValueUsd: 1_300 },
];
